import { render } from "./System.vue?vue&type=template&id=538f485f&scoped=true"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"

import "./System.vue?vue&type=style&index=0&id=538f485f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-538f485f"

export default script